module.exports = __webpack_public_path__ + "img/2022.2喜拼.3ad05e98.png";